// extracted by mini-css-extract-plugin
export var description = "DescriptionBlock2-module--description--RgLD9";
export var content = "DescriptionBlock2-module--content--ShQj1";
export var title = "DescriptionBlock2-module--title--yk4Dg";